import { useEffect, useState } from "react";
import axios from "axios";
import { MapPin } from "lucide-react";
import { API } from "@/lib/config";

export default function ServiceArea() {
  const [tiers, setTiers] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/service-area`)
      .then((res) => setTiers(res.data.tiers))
      .catch(() => setTiers(null));
  }, []);

  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="border-b border-slate-200 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="bid-divider" />
              <span className="bid-eyebrow">Service Area</span>
            </div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight">
              The zip codes
              <br />
              we serve.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-base text-slate-700 leading-relaxed">
              We proudly serve St. Augustine and surrounding communities across
              St. Johns, Flagler, Volusia, Duval, and Clay counties. Don&apos;t
              see your zip? Give us a call — we still serve many nearby areas.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {tiers &&
            Object.entries(tiers).map(([label, data], i) => {
              const { zips } = data;
              return (
                <div
                  key={label}
                  data-testid={`service-tier-${i}`}
                  className="border-2 border-slate-200 bg-white p-6 hover:border-[#002FA7] transition-colors"
                >
                  <div className="font-display font-bold text-lg uppercase tracking-tight leading-tight mb-1">
                    {label}
                  </div>
                  <div className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-4">
                    {zips.length} zip codes
                  </div>
                  <div className="h-px bg-slate-200 mb-4" />
                  <ul className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-1.5">
                    {zips.length === 0 && (
                      <li className="text-sm text-slate-400 col-span-full">
                        No zips in this area
                      </li>
                    )}
                    {zips.map((zip) => (
                      <li
                        key={zip}
                        className="flex items-center gap-1.5 text-sm text-slate-700 font-mono"
                      >
                        <MapPin size={11} className="text-slate-400 shrink-0" />
                        {zip}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
        </div>

        <p className="text-xs text-slate-500 mt-6 uppercase tracking-widest font-bold text-center">
          Don&apos;t see your zip? Call us — we still serve many surrounding areas.
        </p>
      </div>
    </section>
  );
}
